import { render } from "./FetchData.vue?vue&type=template&id=2d8463aa"
import script from "./FetchData.vue?vue&type=script&lang=js"
export * from "./FetchData.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\Repository\\C318-CAF. Portal de Juntas telematicas\\CAF-Solution\\NetCoreWebApi\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__